import React from "react";

const ExploreToggle = ({ activeTab, setActiveTab }) => {
  return (
    <div className="flex gap-2 bg-black rounded-full shadow-sm p-1 w-fit">
      <button
        onClick={() => setActiveTab("projects")}
        className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
          activeTab === "projects"
            ? "bg-white text-black"
            : "text-white hover:bg-gray-800"
        }`}
      >
        Projects
      </button>
      <button
        onClick={() => setActiveTab("people")}
        className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
          activeTab === "people"
            ? "bg-white text-black"
            : "text-white hover:bg-gray-800"
        }`}
      >
        People
      </button>
    </div>
  );
};

export default ExploreToggle;
